<template>
	<div class="index-swiper-view swiper-view">
		<van-swipe v-if="cate_id == 6" :autoplay="2000">
			<van-swipe-item v-for="item in bannerList"
							:key="item.id">
				<div class="swiper-banner-wrap">
					<BannerItem v-bind="item" />
				</div>
			</van-swipe-item>
		</van-swipe>
		<div class="view-list-wrap">
			<div class="digital-list" v-if="!custom">
				<DigitalItem v-for="item in digitalList"
							 :key="item.id"
							 v-bind="item" />
				<div class="no-content"
					 v-show="isNoContent">———— 暂无内容 ————</div>
			</div>
			<div class="content-wrap"
				 v-html="custom"></div>
		</div>
	</div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
import DigitalItem from '../../components/DigitalItem';
import BannerItem from '../../components/BannerItem';
export default {
	name: 'indexSwiperView',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		DigitalItem,
		BannerItem
	},
	props: ['bannerList', 'newsItemList', 'digitalList', 'custom', 'cate_id', 'isNoContent']
};
</script>

<style lang="stylus" scoped>
.index-swiper-view {
	min-height: 1080px;
	.swiper-banner-wrap {
		margin: 30px auto;
		width: 690px;
		height: 273px;
	}

	.news-list {
		padding: 0 15px;
	}

	.digital-list {
		padding: 20px 15px 90px 15px;

		.digital-item-comp {
			margin: 30px 15px 15px 15px;
			vertical-align: top;
		}

		.no-content {
			height: 90px;
			line-height: 90px;
			color: #999;
			text-align: center;
		}
	}

	.content-wrap {
		padding: 0 36px;
		color:#333;
		font-size:30px;
		line-height: 50px;
	}
}
</style>
